import type { BookmarkableType } from '@/types/bookmark/Bookmark'
import type { UUID } from '@/types/Id'

interface BookmarksQueryKeyArgs {
  orgId: UUID | ''
  typeFilter?: BookmarkableType
}

interface BookmarkCheckQueryKeyArgs {
  orgId: UUID | ''
  bookmarkableType: BookmarkableType
  objectId: string
}

export const bookmarksQueryKeys = {
  all: () => ['bookmarks'] as const,
  organization: (keyArgs: BookmarksQueryKeyArgs) =>
    ['bookmarks', keyArgs.orgId, keyArgs.typeFilter] as const,
}

export const bookmarkCheckQueryKeys = {
  all: () => ['bookmark-check'] as const,
  check: (keyArgs: BookmarkCheckQueryKeyArgs) =>
    [
      'bookmark-check',
      keyArgs.orgId,
      keyArgs.bookmarkableType,
      keyArgs.objectId,
    ] as const,
}
